import { render, staticRenderFns } from "./OlpasoIndicator.vue?vue&type=template&id=d0d72d32&scoped=true"
import script from "./OlpasoIndicator.vue?vue&type=script&lang=js"
export * from "./OlpasoIndicator.vue?vue&type=script&lang=js"
import style0 from "./OlpasoIndicator.vue?vue&type=style&index=0&id=d0d72d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d72d32",
  null
  
)

export default component.exports